import React, { useState } from 'react';
import { useDeactivateQuarterMutation, useGetActiveQuarterQuery, useGetAllNominationsQuery } from '../rnrApiSlice';
import RnRNominations from './RnRNominations';
import { Grid, Box } from '@mui/material';
import { Button } from '@mui/material';
import { Pause, PlayArrow } from '@mui/icons-material';
import StartQuarterDialog from './StartQuarterDialog';
import toast from 'react-hot-toast';
import SkeletonTable from './SkeletonTable';

const AdminRnR = () => {
  const { data: currentQuarter, isLoading: isQuarterLoading } = useGetActiveQuarterQuery();
  const [deactivateQuarter] = useDeactivateQuarterMutation();
  const { data, isLoading } = useGetAllNominationsQuery();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isDeactivateButtonClicked, setIsDeactivateButtonClicked] = useState(false);
  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDeactivateQuarter = async () => {
    await toast.promise(
      // Call the deactivateQuarter
      deactivateQuarter(currentQuarter?.data?._id).unwrap(),
      {
        loading: 'Deactivating...',
        success: 'Quarter Deactivated !!',
        error: (err) => err.data?.message || 'Error in Deactivating Quarter, Please try again.',
      }
    );
    setIsDeactivateButtonClicked(true);
  };

  const isCurrentQuarterActive = () => {
    if (!currentQuarter?.data || !currentQuarter?.data.endDate) {
      return false;
    }

    return currentQuarter?.data.active;
  };

  return (
    <Grid container>
      <Grid item xl={12} md={12} sm={12} lg={12} xs={12} direction={'column'}>
        <Box
          sx={{
            border: 1,
            backgroundColor: 'text.wb',
            borderRadius: '8px',
            borderColor: 'divider',
          }}
        >
          {!isCurrentQuarterActive() ? (
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlayArrow />}
              onClick={handleDialogOpen}
              sx={{ float: 'right', zIndex: 1300, mt: 1.5, mr: 1.5 }}
            >
              Start Quarter
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              startIcon={<Pause />}
              onClick={handleDeactivateQuarter}
              sx={{ float: 'right', zIndex: 1300, mt: 1.5, mr: 1.5 }}
            >
              Deactivate Quarter
            </Button>
          )}
          {isQuarterLoading || isLoading ? (
            <SkeletonTable />
          ) : (
            <RnRNominations data={data?.data} currentQuarter={currentQuarter} />
          )}
        </Box>
      </Grid>
      {console.log('currentQuarter', currentQuarter)}
      <StartQuarterDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        isDeactivateButtonClicked={isDeactivateButtonClicked}
        setIsDeactivateButtonClicked={setIsDeactivateButtonClicked}
      />
    </Grid>
  );
};

export default AdminRnR;
